<template>
  <div class="row">
      <div class="col-xl-6 col-lg-12">
          <div class="main-card mb-3 card">
            <div class="card-body">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label>Wardrobe Items</label>
                  <br>
                  <div class="position-relative form-check form-check-inline">
                    <small class="form-check-label" style="color:green;">
                      <input :checked="wardrobe_items.length == wardrobe_items_options.length"
                      type="checkbox" class="form-check-input" @click="check_all_wardrobe_items"> All
                    </small>
                  </div>
                  <br>
                  <div class="position-relative form-check form-check-inline col-md-4 pr-0 mr-0" v-for="(val,key) in wardrobe_items_options" :key="key">
                    <small class="form-check-label">
                      <input type="checkbox" v-model="wardrobe_items" class="form-check-input" :value="val"> {{val.name}}
                    </small>
                  </div>
                </div>
                <div class="col-md-12 mb-3">
                  <label>Ethnic Wardrobe Items</label>
                  <br>
                  <div class="position-relative form-check form-check-inline">
                    <small class="form-check-label" style="color:green;">
                      <input :checked="ethnic_wardrobe_items.length == ethnic_wardrobe_items_options.length"
                      type="checkbox" class="form-check-input" @click="check_all_ethnic_wardrobe_items"> All
                    </small>
                  </div>
                  <br>
                  <div class="position-relative form-check form-check-inline col-md-4 pr-0 mr-0" v-for="(val,key) in ethnic_wardrobe_items_options" :key="key">
                    <small class="form-check-label">
                      <input type="checkbox" v-model="ethnic_wardrobe_items" class="form-check-input" :value="val"> {{val.name}}
                    </small>
                  </div>
                </div>
                <div class="col-md-12 mb-3">
                  <label>Willing To</label>
                  <br>
                  <div class="position-relative form-check form-check-inline">
                    <small class="form-check-label" style="color:green;">
                      <input :checked="willing_to.length == willing_to_options.length"
                      type="checkbox" class="form-check-input" @click="check_all_willing_to"> All
                    </small>
                  </div>
                  <br>
                  <div class="position-relative form-check form-check-inline col-md-4 pr-0 mr-0" v-for="(val,key) in willing_to_options" :key="key">
                    <small class="form-check-label">
                      <input type="checkbox" v-model="willing_to" class="form-check-input" :value="val"> {{val.name}}
                    </small>
                  </div>
                </div>
                <div class="col-md-12 mb-3">
                  <label>Uniforms</label>
                  <br>
                  <div class="position-relative form-check form-check-inline">
                    <small class="form-check-label" style="color:green;">
                      <input :checked="uniforms.length == uniforms_options.length"
                      type="checkbox" class="form-check-input" @click="check_all_uniforms"> All
                    </small>
                  </div>
                  <br>
                  <div class="position-relative form-check form-check-inline col-md-4 pr-0 mr-0" v-for="(val,key) in uniforms_options" :key="key">
                    <small class="form-check-label">
                      <input type="checkbox" v-model="uniforms" class="form-check-input" :value="val"> {{val.name}}
                    </small>
                  </div>
                </div>
                <div class="col-md-12 mb-3">
                  <label>Props</label>
                  <br>
                  <div class="position-relative form-check form-check-inline">
                    <small class="form-check-label" style="color:green;">
                      <input :checked="props.length == props_options.length"
                      type="checkbox" class="form-check-input" @click="check_all_props"> All
                    </small>
                  </div>
                  <br>
                  <div class="position-relative form-check form-check-inline col-md-4 pr-0 mr-0" v-for="(val,key) in props_options" :key="key">
                    <small class="form-check-label">
                      <input type="checkbox" v-model="props" class="form-check-input" :value="val"> {{val.name}}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="col-xl-6 col-lg-12">
          <div class="main-card mb-3 card">
            <div class="card-body">
              <div class="form-row">
                  .........................
              </div>
            </div>
          </div>
      </div>
      <div class="col-md-12 mb-3 text-center">
        <button class="btn btn-warning px-4">Update</button>
      </div>
  </div>
</template>

<script>
export default {
  name: 'FormProfile3',
  props:{
    firstLoad: Object,
    talentData: Object,
  },
  data(){
    return {
      wardrobe_items: [],
      wardrobe_items_options: [],
      ethnic_wardrobe_items: [],
      ethnic_wardrobe_items_options: [],
      willing_to: [],
      willing_to_options: [],
      uniforms: [],
      uniforms_options: [],
      props: [],
      props_options: [],
    }
  },
  created(){
    this.wardrobe_items_options = this.LocalStorage("smetIebordraw",new Array());
  },
  mounted(){
    if(!this.wardrobe_items_options.length)this.get_wardrobe_item();
    this.set_data();
  },
  methods:{
    setup_data(){
      this.set_wardrobe_items();
      this.set_ethnic_wardrobe_items();
      this.set_willing_to();
      this.set_uniforms();
      this.set_props();
    },
    async get_wardrobe_item(){
      var url = this.api+'dataOption/get_wardrobe_item/'+this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
      .then((response)=>{
        console.log(response.data);
        if(response.data.error==0){
          this.wardrobe_items_options = response.data.data;
          localStorage.setItem("smetIebordraw",JSON.stringify(response.data.data));
        }
      })
      .catch((error)=>{
        alert(error);
        console.error(error);
      })
      .then(() => {
        this.set_wardrobe_items()
      })
    },
    set_wardrobe_items(){
      if(!this.talentData.id || !this.wardrobe_items_options.length){
        setTimeout(()=> this.set_wardrobe_items() ,1000);
        return false;
      }
      this.wardrobe_items = JSON.parse( this.talentData.wardrobe_items ) || [];
      this.wardrobe_items.forEach((e,i)=>{
        let index = this.wardrobe_items_options.findIndex(x => x.id == e);
        this.wardrobe_items[i] = this.wardrobe_items_options[index];
      })
    },
    check_all_wardrobe_items(){
      if(this.wardrobe_items.length == this.wardrobe_items_options.length){
        this.wardrobe_items = [];
      }else{
        this.wardrobe_items = this.wardrobe_items_options;
      }
    },
  },
}
</script>

<style scoped>
.containerTooltip{ position: relative; }
.hovTol1{ display: none; }
.containerTooltip input:focus + .hovTol1{
  display: block;
  position: absolute;
  top: -10px;
  left: 3px;
  padding: 5px;
  border-radius: 5px;
  background: #343a40;
  color: #fff;
}
textarea{ resize: none !important; }
</style>
